// libraries.
import { useDispatch } from 'react-redux';

// components.
import { ButtonSidebar } from '@shared';

// assets.
import { IconWarning } from '@assets/icons';

// slices.
import { selectSidebarButton } from '@shared/Sidebar/store/slices/sidebar-slice';

// interfaces.
import { SidebarPolygonTool } from '../../../interfaces/sideBar.types';

export const ButtonAuditPolygons = () => {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(selectSidebarButton(SidebarPolygonTool.auditPolygons));
  };

  return (
    <ButtonSidebar
      icon={<IconWarning width="20" height="20" />}
      text="Auditar polígonos"
      onClick={handleClick}
    />
  );
};
